import { selectProposalInfo } from '../../selectors/proposal';
import { useSelector } from 'react-redux';
import { MortgageSteps } from '../../components/MortgageSteps';
import { prepareSteps } from '../../utils/textUtils/prepareSteps';
import { IMortgageStep } from '../../types/proposal';

const steps: IMortgageStep[] = [
  {
    title: 'Выберите квартиру',
    description:
      'Ищите объявления со значком «Скидка на ипотеку {mortgageRateDiscount}%» и звоните продавцу. А если вам понравится квартира без значка, нажмите на «Скидка {mortgageRateDiscount}%. Предложите продавцу» — так автор объявления узнает о программе.',
  },
  {
    title: 'Оставьте заявку на ипотеку',
    description: 'Когда выберете квартиру, подайте заявку на ипотеку в банк напрямую с объявления',
  },
  {
    title: 'Получите одобрение от банка',
    description: 'Банк одобрит ипотеку и вы сможете выходить на сделку',
  },
  {
    title: 'Оформите сделку',
    description: 'Подпишите договор  — в нём будет прописана пониженная ставка на {discountRateDuration}',
  },
];

export const MortgageStepsContainer = () => {
  const proposalInfo = useSelector(selectProposalInfo);
  const mortgageSteps: IMortgageStep[] = prepareSteps(steps, proposalInfo);

  return <MortgageSteps detailsLink={proposalInfo.detailsLink} steps={mortgageSteps} />;
};
